// extracted by mini-css-extract-plugin
module.exports = {"root":"EmbedGameNotSupported_root_y1-Zx","content":"EmbedGameNotSupported_content_21bmC"};